module.exports = __webpack_public_path__ + "media/images/vouchers/balneo_duo-324b8ee03ff326af36152a54c7e93987.png";